import { useQuery } from '@tanstack/react-query';
import { tradesService } from '@/services';
import { queryKeys } from '@/services/query-keys';

export const useTradeDetail = (id: number, enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.trades.detail(id),
    queryFn: () => tradesService.getTradeDetail(id),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: enabled && id > 0,
  });
};
